import React, {useState} from "react";
import { Box, Button, Column, Columns, Control, File, Modal, Section } from "@allxsmith/bestax-bulma";
import {useDispatch, useSelector} from "react-redux";
import Spinner from "react-spinner-material";
import ImageDisplay from "./Defects/ImageDisplay";
import axios from "axios";
import {createSetDataFreshAction} from "../../actions/dataActions";
import {onFileChange, triggerUpload} from "../../utils";
import {ToastContainer, toast} from "react-toastify";
import LoadingSpinner from "../Utils/Spinner";


export default function ImageModal({open, setOpen, job, dataFresh, type, imagesLoaded, images}){
    const dispatch = useDispatch();
    const [fileList, setFileList] = useState();
    let params = {type: type}
    // if(job && job.vehicle){
    //     params.blob_name = job.vehicle.registration+"-"+job.id;
    //     params.id = job.id
    // }
    // let imagesLoaded = useImagesData(params, dataFresh);
    // let images = useSelector(getImagesData);

    const deleteImage = id => {
        const conf = {
              url: "/api/deleteinternalimage/"+id,
              method: "delete"
        };
        axios(conf).catch(err => toast.error("There was an error deleting the image"));
    }

    if(!imagesLoaded){
        return (
            <LoadingSpinner/>
        );
    }

    const onUploadedFileDelete = (e, index) =>{
        //get blob name from url
        let url = images[index].url;
        // url format : https://storage.googleapis.com/bucket_name/blob_name?googleaddedstuff
        if(url){
            let split_url = url.split("/") // Splits into 5 chunks 0-4
            let blob_name = split_url[4].split("?")[0]
            const conf = {
                url: "/api/deleteimage?blob_name="+blob_name+"&blob_prefix="+job.vehicle.registration+"-"+job.id,
                method: "post"
            }
            axios(conf).then(res=>{
                dispatch(createSetDataFreshAction(dataFresh + 1))
            }).catch(err => {
                toast.error("There was an error",  {position: "top-right"})
            })
        }

    };


    const onFileDelete = (e, index) => {
        let dataTransfer = new DataTransfer();
        for(let i=0; i<fileList.length;i++){
          if(i !== index){
            dataTransfer.items.add(fileList[i]);
          }
        }
        setFileList(dataTransfer.files);
    }
    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    // TODO(bestax-migrate): `inputProps` — spread these onto bestax File directly
    return (
        <Modal
            active={open}
            closeOnBlur
            onClose={() => {
                setFileList(undefined)
                setOpen(false)
            }}
        >
            <Modal.Content
                className={"wider-modal"}
            >
                <Section style={{backgroundColor: "white"}}>
                    <Columns isMultiline>
                        <Column>
                            <ImageDisplay
                                imageList={images}
                                onImageDelete={onUploadedFileDelete}
                            />
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        {fileList &&
                            <Column>
                                <h2>Images to Upload</h2>
                                <ImageDisplay
                                    displayHeader={false}
                                    fileList={fileList}
                                    onImageDelete={onFileDelete}
                                />
                            </Column>
                        }
                        <Column>
                            <label className="label">File Upload</label>
                            <Control>
                                <File
                                    onChange={(e) => onFileChange(e, fileList, setFileList)}
                                    multiple={true}
                                />
                            </Control>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                color={"success"}
                                onClick={() => {
                                    triggerUpload(fileList, job.id, job.vehicle, setFileList, deleteImage, dataFresh, dispatch, type);
                                }}
                                isFullWidth
                            >
                                Upload
                            </Button>
                        </Column>
                        <Column>
                            <Button
                                color={"info"}
                                onClick={() => setOpen(false)}
                                isFullWidth
                            >
                                Close
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );

}